<template>
  <div class="item_content">
    <div
      class="item_title"
      style="display: flex; justify-content: space-between"
    >
      <div>
        {{ ProductItem.Name }}
      </div>
      <div style="width: 70px; color: red; font-size: 13pt; height: 30px">
        {{ ProductItem.PriceFormat }}
      </div>
    </div>

    <div class="item_content_area" @click="LookProductDetail(ProductItem)">
      <van-image
        class="item_picture"
        fit="contain"
        :src="ProductItem.CompleteImages"
      >
        <template v-slot:error> </template>
      </van-image>

      <div class="item_price_cart">
        <p class="description">
          {{ ProductItem.Description }}
        </p>
      </div>
    </div>
    <div class="item_bottom">
      <div>
        {{ tools.GetLanguageValue("public.app.已点") }}
        {{ ProductItem.PlaceCount }}
      </div>
      <div class="stepper_content">
        <van-stepper
          :disable-plus="DisablePlus"
          v-model="ProductItem.Count"
          :disable-input="true"
          :min="0"
          @minus="MinusCartItem()"
          @plus="GetProduct()"
          v-if="ProductItem.Count > 0"
          :before-change="beforeChange"
        />

        <div
          v-if="ProductItem.Count == 0"
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex: 1;
            font-size: 18pt;
            color: rgb(29, 29, 29);
            height: 40px;
          "
        >
          <div style="line-height: 40px">
            {{ ProductItem.Count }}
          </div>
          <van-icon
            name="shopping-cart"
            @click="GetProduct()"
            color="rgb(0, 157, 255)"
            size="17pt"
          />
        </div>
      </div>
    </div>
  </div>
  <van-action-sheet v-model:show="AttributeShow" :title="Product.Name">
    <div class="attribute_content">
      <div style="" :style="{ height: clientHeight + 'px' }">
        <div style="width: 100%; text-align: center">
          <van-swipe :autoplay="3000" lazy-render>
            <van-swipe-item
              v-for="(itemp, index) in Product.Pictures"
              :key="index"
            >
              <img :src="itemp.CompleteImageFormet" style="width: 80%" />
            </van-swipe-item>
          </van-swipe>
        </div>

        <van-col
          span="24"
          style="
            position: absolute;
            bottom: 5px;
            width: 100%;
            text-align: center;
            z-index: 1000000;
          "
        >
          <!-- <van-stepper input-width="60px" button-size="60px" v-model="ProductItem.Count" :disable-input="true" :min="1"
            @plus="AddShoppingCart()" @minus="MinusCartItem()"  max="999"
            :before-change="beforeChange" /> -->

          <van-button
            @click="AddShoppingCart()"
            style="width: calc(100% - 50px)"
            color="rgb(0, 157, 255)"
          >
            {{ tools.GetLanguageValue("public.app.添加") }}
          </van-button>
        </van-col>
        <div style="width: 100%; text-align: center">
          {{ Product.Remarks }}
        </div>
        <div v-for="(item, index) in Product.Groups" :key="index">
          <AttributeGroupModule
            :AttributeGroup="item"
            v-model="item.ProductAttributeOpt"
          />
        </div>

        <div style="padding: 10px 20px; margin-top: 30px">
          <p v-if="ProductItem.RemarkRequiredMaxCount > 0">
            {{ tools.GetLanguageValue("public.app.最多可以选择") }}
            {{ ProductItem.RemarkRequiredMaxCount }}
            {{ tools.GetLanguageValue("system.public.个") }}
          </p>
          <van-checkbox-group
            v-model="ProductRemarkOpts"
            direction="horizontal"
            :max="ProductItem.RemarkRequiredMaxCount"
          > 
            <div
              v-for="item in Product.ProductRemarkFree"
              :key="item.Id"
              class="product_remark"
            >
              <van-checkbox icon-size="20" shape="square" :name="item">
                <span style="font-size: 12pt; margin: 5px">
                  {{ item.Name + ProductItem.PriceFormat }}
                </span>
              </van-checkbox>
            </div>
            <div
              v-for="item in Product.ProductRemarkCollectFree"
              :key="item.Id"
              class="product_remark"
            >
              <van-checkbox icon-size="20" shape="square" :name="item">
                <span style="font-size: 12pt">
                  {{ item.Name + ProductItem.PriceFormat }}
                </span>
              </van-checkbox>
            </div>
          </van-checkbox-group>
          <br />
          <br />
          <br />
        </div>

        <div style="padding: 5px 5px 20px 5px">
          {{ ProductItem.Description }}
        </div>
      </div>
      <van-row> </van-row>
    </div>
  </van-action-sheet>
</template> 
<script >
import axios from "../../commons/AxiosMethod.js";
import tools from "../../commons/tools.js";
import AttributeGroupModule from "../AttributeGroupModule.vue";
import { Toast } from "vant";
export default {
  data() {
    return {
      productImg: require("../../assets/正方形logo.png"),
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Product: {
        Count: 0,
      }, //商品
      tools: tools,
      AttributeShow: false, //显示属性面板
      ProductAttributeOpt: [], //选中属性
      ProductRemarkOpts: [], //选中备注
      TableId: "", //桌台ID
      DisablePlus: false,
      IsAddCartDetail: false, //添加的时候显示详情
    };
  },
  name: "App",
  props: {
    ProductItem: {},
  },
  mounted() {
    this.Product = this.ProductItem;
    this.ProductRemarkOpts = [];
    this.TableId = localStorage.getItem("Cache-TableId");

    var addcartDetailed = localStorage.getItem("addcartDetailed");

    this.IsAddCartDetail = addcartDetailed != "yes";
  },
  components: {
    AttributeGroupModule,
  },
  methods: {
    beforeChange(value) {
      console.log(value);
    },
    //查看详细页面
    LookProductDetail(product) {
      let param = { Id: this.ProductItem.Id };
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          this.Product = result.Data;
          this.AttributeShow = true;
        }
      );
    },
    //获取商品
    GetProduct() {
      let param = { Id: this.ProductItem.Id };
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          try {
            if (result.Code == 200) {
              this.Product = result.Data;

              if (result.Data.IsRemarkRequired || result.Data.IsRequired) {
                this.AttributeShow = true;
                return;
              }
              {
                var addcartDetailed = localStorage.getItem("addcartDetailed");

                if (addcartDetailed != "yes") {
                  this.AddShoppingCart();
                  return;
                } else {
                  this.AttributeShow = true;
                }
                // this.AddShoppingCart();
              }
            } else {
              Toast(result.FullMsg);
            }
          } catch (error) {}
        }
      );
      this.DisablePlus = false;
    },
    //添加购物车
    AddShoppingCart() {
      let param = {
        ProductId: this.Product.Id,
        Count: 1,
        Remarks: this.Product.Remarks,
        OptProductRemarkItems: this.ProductRemarkOpts,
        ProductRemarkItemsOpt: this.ProductRemarkOpts,
        ProductAttributeGroups: this.Product.Groups,
        TableId: this.TableId,
      };

      this.DisablePlus = true;

      axios.apiMethod(
        "/Store/StoreOrder/AddShoppingCart",
        "post",
        param,
        (result) => {
          try {
            if (result.Data.IsSuccess) {
              Toast(result.Data.Msg);
              this.ProductRemarkOpts = [];
              // this.AttributeShow = false;
              this.ProductItem.Count += 1;

              tools.GetShoppingCartComplete(this.TableId);
            } else {
              Toast(result.Data.Msg);
              this.ProductItem.Count -= 1;
              if (this.ProductItem.Count <= 0) {
                this.ProductItem.Count = 0;
              }
            }
          } catch (error) {}
          this.DisablePlus = false;
        }
      );
    }, //减少商品
    MinusCartItem() {
      axios.apiMethod(
        "/Store/StoreOrder/CutShoppingCartByProductId",
        "post",
        {
          ProductId: this.Product.Id,
          TableId: this.TableId,
        },
        (result) => {
          if (result.Data.IsSuccess) {
            this.ProductItem.Count = result.Data.Model.Count;
            tools.GetShoppingCartComplete(this.TableId);

            return;
          }
          Toast(result.Data.Msg);
        },
        (e) => {}
      );
    },
  },
};
</script>
 
 
<style lang="scss" scoped>
.product_remark {
  padding: 5px 22px;
  font-size: 7pt;
}

.item_content {
  max-width: 100%;
  height: 180px;
  background-color: #fff;
  padding: 15px;
  border-radius: 15px;

  .pricture_name {
    color: #333;
    font-size: 11pt;
    width: calc(100% - 70px);
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    margin-left: 10px;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);
    height: 100px;
    border-radius: 5px;
    display: flex;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 125px;
      height: 80px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: calc(100% - 135px);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 60px;
          line-height: 40px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}

.attribute_content {
}

.stepper_content {
  display: flex;
  width: 100px;
  text-align: right;
  height: 40px;
  line-height: 40px;
}

.item_bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
</style>
